!(function (e) {
  function t(t) {
    for (
      var n, a, l = t[0], u = t[1], s = t[2], d = 0, f = [];
      d < l.length;
      d++
    )
      (a = l[d]),
        Object.prototype.hasOwnProperty.call(o, a) && o[a] && f.push(o[a][0]),
        (o[a] = 0);
    for (n in u) Object.prototype.hasOwnProperty.call(u, n) && (e[n] = u[n]);
    for (c && c(t); f.length; ) f.shift()();
    return i.push.apply(i, s || []), r();
  }
  function r() {
    for (var e, t = 0; t < i.length; t++) {
      for (var r = i[t], n = !0, l = 1; l < r.length; l++) {
        var u = r[l];
        0 !== o[u] && (n = !1);
      }
      n && (i.splice(t--, 1), (e = a((a.s = r[0]))));
    }
    return e;
  }
  var n = {},
    o = { main: 0 },
    i = [];
  function a(t) {
    if (n[t]) return n[t].exports;
    var r = (n[t] = { i: t, l: !1, exports: {} });
    return e[t].call(r.exports, r, r.exports, a), (r.l = !0), r.exports;
  }
  (a.e = function (e) {
    var t = [],
      r = o[e];
    if (0 !== r)
      if (r) t.push(r[2]);
      else {
        var n = new Promise(function (t, n) {
          r = o[e] = [t, n];
        });
        t.push((r[2] = n));
        var i,
          l = document.createElement("script");
        (l.charset = "utf-8"),
          (l.timeout = 120),
          a.nc && l.setAttribute("nonce", a.nc),
          (l.src = (function (e) {
            return (
              a.p +
              "" +
              ({
                fadeInSlider: "fadeInSlider",
                airIdeal: "airIdeal",
                topMainVisual: "topMainVisual",
              }[e] || e) +
              ".module.bundle.js"
            );
          })(e));
        var u = new Error();
        i = function (t) {
          (l.onerror = l.onload = null), clearTimeout(s);
          var r = o[e];
          if (0 !== r) {
            if (r) {
              var n = t && ("load" === t.type ? "missing" : t.type),
                i = t && t.target && t.target.src;
              (u.message =
                "Loading chunk " + e + " failed.\n(" + n + ": " + i + ")"),
                (u.name = "ChunkLoadError"),
                (u.type = n),
                (u.request = i),
                r[1](u);
            }
            o[e] = void 0;
          }
        };
        var s = setTimeout(function () {
          i({ type: "timeout", target: l });
        }, 12e4);
        (l.onerror = l.onload = i), document.head.appendChild(l);
      }
    return Promise.all(t);
  }),
    (a.m = e),
    (a.c = n),
    (a.d = function (e, t, r) {
      a.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
    }),
    (a.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (a.t = function (e, t) {
      if ((1 & t && (e = a(e)), 8 & t)) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (
        (a.r(r),
        Object.defineProperty(r, "default", { enumerable: !0, value: e }),
        2 & t && "string" != typeof e)
      )
        for (var n in e)
          a.d(
            r,
            n,
            function (t) {
              return e[t];
            }.bind(null, n)
          );
      return r;
    }),
    (a.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return a.d(t, "a", t), t;
    }),
    (a.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (a.p = "/air/js/"),
    (a.oe = function (e) {
      throw (console.error(e), e);
    });
  var l = (window.webpackJsonp = window.webpackJsonp || []),
    u = l.push.bind(l);
  (l.push = t), (l = l.slice());
  for (var s = 0; s < l.length; s++) t(l[s]);
  var c = u;
  i.push([54, "vendor"]), r();
})({
  109: function (e, t, r) {
    "use strict";
    r.r(t);
    r(56), r(83), r(89), r(90);
    var n = r(51),
      o = r.n(n),
      i = r(52),
      a = r.n(i);
    function l(e, t) {
      var r = { time: !1, complete: !1 },
        n = 3e3,
        i = document.querySelector(".brand-Wrapper"),
        l = t.filter(Boolean),
        u = new o.a.Circle(e, {
          color: "#0097e0",
          trailColor: "#eee",
          strokeWidth: 1,
          trailWidth: 1,
          easing: "easeInOut",
          duration: 2e3,
        });
      function s() {
        r.time && r.complete && i.classList.add("-is-loaded");
      }
      i.classList.add("-is-start"),
        setTimeout(() => {
          r.time = !0;
        }, n),
        Object.getOwnPropertyNames(r).forEach((e) =>
          (function (e, t, r) {
            var n = e[t];
            Object.defineProperty(e, t, {
              get: () => n,
              set: (e) => {
                var t = n;
                (n = e), r(t, e);
              },
              configurable: !0,
            });
          })(r, e, s)
        );
      var c = new a.a.LoadQueue();
      c.setMaxConnections(6),
        c.on("progress", (e) => {
          var t = e.progress.toFixed(1);
          u.animate(t),
            1 === e.progress &&
              ((r.complete = !0),
              r.time && r.complete && i.classList.add("-is-loaded"));
        }),
        c.loadManifest(l, !1),
        c.load();
    }
    var u = r(47),
      s = r.n(u);
    function c(e, t, r, n, o, i, a) {
      try {
        var l = e[i](a),
          u = l.value;
      } catch (e) {
        return void r(e);
      }
      l.done ? t(u) : Promise.resolve(u).then(n, o);
    }
    function d(e) {
      return function () {
        var t = this,
          r = arguments;
        return new Promise(function (n, o) {
          var i = e.apply(t, r);
          function a(e) {
            c(i, n, o, a, l, "next", e);
          }
          function l(e) {
            c(i, n, o, a, l, "throw", e);
          }
          a(void 0);
        });
      };
    }
    new (class {
      constructor() {
        (this.ua = new s.a()),
          (this.uaResult = this.ua.getResult()),
          (this.homeHero = document.querySelector("#js-air-hero")),
          (this.airIdeal = document.querySelector("#js-air-ideal")),
          (this.slider = document.querySelector(".js-slider")),
          (this.IEPositionFixedBugFix = () => {
            event.preventDefault();
            var e = event.wheelDelta,
              t = window.pageYOffset;
            window.scrollTo(0, t - e);
          }),
          this.bind();
      }
      bind() {
        if (this.homeHero) {
          (navigator.userAgent.match(/MSIE 10/i) ||
            navigator.userAgent.match(/Trident\/7\./) ||
            navigator.userAgent.match(/Edge\/12\./)) &&
            document
              .querySelector("body")
              .addEventListener("mousewheel", this.IEPositionFixedBugFix);
          for (
            var e = document.querySelectorAll("img"), t = [], n = 0;
            n < e.length;
            n++
          )
            t.push(e[n].src);
          d(function* () {
            yield l("#js-progress", t);
            var e = yield Promise.all([
              r.e("vendor"),
              r.e("topMainVisual"),
            ]).then(r.bind(null, 115));
            yield e.default();
          })();
        }
        if (this.airIdeal) {
          for (
            var o = document.querySelectorAll("img"),
              i = document.querySelector("#js-main-video"),
              a = [],
              u = 0;
            u < o.length;
            u++
          )
            a.push(o[u].src);
          if ("mobile" === this.ua.getDevice().type) {
            a.some((e, t) => {
              -1 !== e.indexOf("img_ideal-image-slider-sp") && a.splice(t, 1);
            });
          }
          a.push(i.currentSrc),
            d(function* () {
              yield l("#js-progress", a);
              var e = yield Promise.all([r.e("vendor"), r.e("airIdeal")]).then(
                r.bind(null, 116)
              );
              yield e.default();
            })();
        }
        this.slider &&
          d(function* () {
            var e = yield r.e("fadeInSlider").then(r.bind(null, 117));
            yield e.default();
          })();
      }
    })();
  },
  54: function (e, t, r) {
    r(55), (e.exports = r(109));
  },
  55: function (e, t) {},
});
